import React from 'react';
import PropTypes from 'prop-types';
import PersonalDataSummary from './PersonalDataSummary';
import { FieldSet } from '../../elements';
import DocumentsView from './DocumentsView';
import PendencyList from './PendencyList';
import AppropriationHistory from './AppropriationHistory';

const DocumentsDetailsView = ({
  personalData,
  personalDocumentsTypes,
  personalDocuments,
  pendencies,
  loadingPendencies,
  showPendencies,
  onApproveDocument,
  onReproveDocument,
  reloadPendencies,
  enrollmentId,
  showActions,
  onHandleAction,
  canAuditDocuments,
  canEditPendencies,
  showAppropriationHistory,
  appropriations,
  canTransferAppropriation,
  onTransferAppropriation,
  loadingAppropriation
}) => (
  <>
    <PersonalDataSummary
      personalData={personalData}
      showActions
      onHandleAction={onHandleAction}
    />
    <FieldSet title="DOCUMENTOS" />
    <div className="documents-base row">
      <DocumentsView
        audittableDocuments
        personalDocuments={personalDocuments}
        personalDocumentsTypes={personalDocumentsTypes}
        onApproveDocument={onApproveDocument}
        onReproveDocument={onReproveDocument}
        canAuditDocuments={canAuditDocuments}
      />
    </div>

    {showPendencies && (
      <PendencyList
        enrollmentId={enrollmentId}
        pendencies={pendencies}
        reloadPendencies={reloadPendencies}
        loadingPendencies={loadingPendencies}
        canEdit={canEditPendencies}
      />
    )}

    {showAppropriationHistory && (
      <AppropriationHistory
        appropriations={appropriations}
        canTransfer={canTransferAppropriation}
        onTransfer={onTransferAppropriation}
        loading={loadingAppropriation}
      />
    )}
  </>
);

DocumentsDetailsView.propTypes = {
  showActions: PropTypes.bool,
  onHandleAction: PropTypes.func,
  personalData: PropTypes.arrayOf(
    PropTypes.shape({
      profile_img_url: PropTypes.string,
      real_name: PropTypes.string,
      assumed_name: PropTypes.string,
      nationality: PropTypes.string,
      birth_country: PropTypes.string,
      birth_state: PropTypes.string,
      birth_city: PropTypes.string,
      cpf: PropTypes.string,
      rne: PropTypes.string,
      birth_date: PropTypes.string,
      marital_status: PropTypes.string,
      gender: PropTypes.string,
      rg_issuing_body: PropTypes.string,
      rg_issue_date: PropTypes.string,
      electoral_card: PropTypes.string,
      military_certificate: PropTypes.string,
      fathers_name: PropTypes.string,
      mothers_name: PropTypes.string,
      email: PropTypes.string,
      phone_number: PropTypes.string,
      landline: PropTypes.string,
      extra_phone_number: PropTypes.string,
      zip_code: PropTypes.string,
      street_address: PropTypes.string,
      address_number: PropTypes.string,
      complement_address: PropTypes.string,
      neighborhood: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string
    })
  ),
  personalDocumentsTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ),
  personalDocuments: PropTypes.arrayOf(
    PropTypes.shape({
      document_type: PropTypes.number,
      external_url: PropTypes.string,
      id: PropTypes.number,
      key: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string
    })
  ),
  pendencies: PropTypes.arrayOf(PropTypes.object),
  loadingPendencies: PropTypes.bool,
  showPendencies: PropTypes.bool,
  canAuditDocuments: PropTypes.bool,
  canEditPendencies: PropTypes.bool,
  showAppropriationHistory: PropTypes.bool,
  appropriations: PropTypes.arrayOf(PropTypes.object),
  canTransferAppropriation: PropTypes.bool,
  onTransferAppropriation: PropTypes.func,
  loadingAppropriation: PropTypes.bool
};

DocumentsDetailsView.defaultProps = {
  personalData: [],
  personalDocumentsTypes: [],
  personalDocuments: [],
  pendencies: [],
  loadingPendencies: false,
  showPendencies: true,
  onApproveDocument: () => undefined,
  showActions: false,
  onHandleAction: () => null,
  canAuditDocuments: true,
  canEditPendencies: true,
  showAppropriationHistory: false,
  appropriations: [],
  canTransferAppropriation: false,
  onTransferAppropriation: () => undefined,
  loadingAppropriation: false
};

export default DocumentsDetailsView;
